import { render, staticRenderFns } from "./LiveOpsRouter.vue?vue&type=template&id=4b6eb8a6"
import script from "./LiveOpsRouter.vue?vue&type=script&lang=js"
export * from "./LiveOpsRouter.vue?vue&type=script&lang=js"
import style0 from "./LiveOpsRouter.vue?vue&type=style&index=0&id=4b6eb8a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports